var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-upload-description-list-wrapper"},[_c('custom-descriptions',_vm._b({ref:"contentItem",attrs:{"data":_vm.localData,"field-list":_vm.localFieldList}},'custom-descriptions',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }